import { em } from '@mantine/core';

const APP_CONFIG = {
	QUERY_STALE_TIME: 30_000,
	QUERY_CACHE_TIME: 1_800_000,
	QUERY_RETRY: 2,
	Z_INDEX: {
		TOOLBAR: 10,
		OVERLAY: 50,
		SCROLL_TOP: 50,
		NOTIFICATION: 100,
		DRAWER: 301,
		MODAL: 301,
		POPOVER: 302,
		TOOLTIP: 302,
		SELECT: 302,
		CREATOR_LOADING: 303,
		MODEL_VIEWER: 304,
		MODAL_INSTRUCTION: 504,
	},
	BREAKPOINTS: {
		XS: em(576),
		SM: em(768),
		MD: em(992),
		LG: em(1200),
		XL: em(1408),
	},
	DEFAULT_LANGUAGE: 'PL',
	HOST_URL: 'https://rtwork-esd.com/',
	COMPANY_DATA: {
		NAME: 'Robtools SMT Sp. z o.o.',
		PHONE: '+48 786-861-254',
		EMAIL: 'info@robtools.pl',
	},
	AUTO_SAVE: {
		TEMP_PROJECT_KEY: 'tempProject',
		INTERVAL: 30_000,
	},
	CART: {
		KEY: 'cart',
	},
	AVAILABLE_BACKGROUNDS: [
		'#808080',
		'#F5F5DC',
		'#FFFFFF',
		'#000000',
		'#424242',
		'#C9C9C9',
		'#FFD8A8',
		'#6BA539',
	],
	DEFAULT_BACKGROUND: '#696969',
} as const;

export default APP_CONFIG;
